import { AxiosRequestConfig } from 'axios'
import { Heater, HeaterInput, HeaterQuery } from '../types'
import { useApi } from '../hooks'

const api = useApi('v2')

export async function getHeaters(
  query: HeaterQuery = {},
  config?: Omit<AxiosRequestConfig, 'params'>
): Promise<Heater[]> {
  const response = await api.get(`/heaters`, {
    params: query,
    ...config
  })

  return response.data
}

export async function createHeater(
  input: HeaterInput,
  config?: AxiosRequestConfig
): Promise<Heater> {
  const response = await api.post(`/heaters`, input, config)

  return response.data
}

export async function getHeater(id: string, config?: AxiosRequestConfig): Promise<Heater> {
  const response = await api.get(`/heaters/${id}`, config)

  return response.data
}

export async function updateHeater(
  id: string,
  input: HeaterInput,
  config?: AxiosRequestConfig
): Promise<Heater> {
  const response = await api.patch(`/heaters/${id}`, input, config)

  return response.data
}

export async function deleteHeater(id: string, config?: AxiosRequestConfig): Promise<void> {
  await api.delete(`/heaters/${id}`, config)
}
